<script>
  import { SeriesArticleNav } from "nature-immersive-svelte-components";

  export let seriesArticleNavData;
</script>

<style>
  .container {
    padding: var(--s0);
    background-color: var(--white-1);
    border-radius: 5px;
  }
</style>

<div class="container">
  <SeriesArticleNav
    {seriesArticleNavData}
    message="Show articles in the series"
    expandedMessage="Hide articles in the series"
    on:update />
</div>
